import { PAYMENT_DATA} from "~/constants/api/payment/payment";

export async function getPaymentData() {
    return await useApi(`${PAYMENT_DATA}`, 'GET');
}